import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class ChargesService {
  constructor(private http: HttpClient) {}

  createCharge(payload: any) {
    return this.http.post(`${environment.apiUrl}/charges/create`, payload);
  }

  updateChargeByClientId(cleintId: string, payload: any) {
    return this.http.put(
      `${environment.apiUrl}/charges/update/${cleintId}`,
      payload
    );
  }

  updateChargeByClientIdAndMonth(
    clientId: string,
    month: number,
    year: number,
    payload: any
  ) {
    return this.http.put(
      `${environment.apiUrl}/charges/update/${clientId}/${month}/${year}`,
      payload
    );
  }

  getChargesByClientId(clientID: string) {
    return this.http.get(
      `${environment.apiUrl}/charges/getByClientId/${clientID}`
    );
  }

  getChargesByMonth(month: number, year: number) {
    return this.http.get(
      `${environment.apiUrl}/charges/month/${month}/${year}`
    );
  }

  getPagedCharges(payload: {
    pageIndex: number;
    pageSize: number;
    sortField?: string;
    sortOrder?: number;
    clientID: string;
  }) {
    const requestPayload = {
      ...payload,
    };
    return this.http.post(
      `${environment.apiUrl}/charges/get-paged`,
      requestPayload
    );
  }
}
